import tafNetwork from '@huyafed/taf-network';
import VodPlayer from '@huyasdk/web_huya_vod';
import { isMock, isDebug, isPro, videoUI } from 'amkit3-modules/utils/constant';
import cookie from 'amkit3-modules/utils/cookie';
import VideoReqHeader from 'amkit3-modules/utils/taf/jce/VideoReqHeader';
 import GameLiveBase from 'amkit3-modules/utils/taf/jce/GameLiveBase';
export const uris = {
  10220051: GameLiveBase.HuYaUdbNotify,
}
const sdk = new tafNetwork({
  isDebug: !isPro,
  showLog: isDebug,
  useMock: isMock,
  uris,
  isApp: false,
  pid:Number(cookie.get('udb_uid')) || 0,
  uris,
  customHeaders: {
    HUYA_NET: 0,
    HUYA_VSDKUA: VodPlayer.SDK_UA || '',
  },
});
export const listenNotice = (uri, cb) => {
  sdk.addListener(uri, cb )
  sdk.listen()
  return () => sdk.clearAll()
}
export const getHuyaVideoUserId = () => {
  const userId = new VideoReqHeader.UserId();
  userId.lUid = Number(cookie.get('udb_uid')) || 0;
  userId.sHuYaUA = 'webh5&1.0.0&huyavideo';
  userId.sCookie = document.cookie.replace(/\s/g, '');
  return userId;
};

export const getVideoReqHeader = () => {
  const videoReq = new VideoReqHeader.VideoReqHeader();
  videoReq.userId = getHuyaVideoUserId();
  return videoReq;
};

/**
 * @description 接口状态码检查。不成功则打log
 */
const responseCodeChecker = ({ funcName, result }) => {
  const codeFields = ['bcode', 'sdkcode'];
  const errorCodeFieldFound = codeFields.find(
    (code) => result && result[code] !== 0
  );

  if (errorCodeFieldFound) {
    const message = `${funcName}接口失败，状态码${errorCodeFieldFound}: ${result ? result[errorCodeFieldFound] : result
      }`;
    console.error(message, result);
    return '服务繁忙，请稍候再试';
  } /* else if (successCodes.includes(result?.data?.code)) {
    log('result.data.code', result?.data?.code)
  } */
};

export const tafRequest = ({
  moduleName = videoUI,
  funcName,
  reqClass,
  rspClass,
  timeout = 10000,
  data,
}) =>
  new Promise((resolve, reject) => {
    /**
     * @description
     * tafFetch 内部封装的定时器有兼容问题
     * 只有极短时间的才会触发
     * https://git.huya.com/huyafed/components/taf -fetch/-/blob/master/src/tafFetch.js#L27
     * https://git.huya.com/huyafed/components/taf -fetch/-/blob/master/src/TafBase.js#L1453
     */
    const timer = setTimeout(() => {
      reject(new Error(`请求超时：${timeout}ms`));
    }, timeout);

    sdk
      .sendWup(
        funcName,
        { reqHeader: getVideoReqHeader(), ...(data || {}) },
        reqClass,
        rspClass,
        moduleName
      )
      .then((res) => {
        const result = {
          bcode: res ? res.bcode : 0,
          sdkcode: res ? res.sdkcode : 0,
          ...(res ? res.data : {} || {}),
        };
        const errorMessage = responseCodeChecker({ funcName, result });
        if (errorMessage) {
          reject(new Error(errorMessage));
        } else {
          if (moduleName === videoUI && result.respHeader.code !== 0) {
            reject(new Error(result.respHeader.msg));
          }
          resolve(result);
        }
      })
      .catch((error) =>
        reject(
          new Error(
            error ? error.message : String(error || '服务繁忙，请稍候再试')
          )
        )
      )
      .finally(() => clearTimeout(timer));
  });
